import { DataContext } from 'entries/common/widgets/context';
import { useContext } from 'react';
import { LAMINATE_CALCULATOR_IDS } from 'pages/common/consts/calculator-ids';

export const useIsLaminateCalculator = () => {
  const data = useContext(DataContext);
  const calculatorId = data?.surfaces?.id || '';
  return LAMINATE_CALCULATOR_IDS.includes(calculatorId);
};
